/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneJwVideoArticle from 'base/components/standalone/JwVideo/Article';

export const DynamicStandaloneJwVideoArticle = StandaloneJwVideoArticle;
export type DynamicStandaloneJwVideoArticleProps = PropsFromComponent<typeof StandaloneJwVideoArticle>;

export const DynamicStandaloneJwVideoArticleWith = (extras: DynamicStandaloneExtras): typeof StandaloneJwVideoArticle => {
    return function DynamicStandaloneJwVideoArticle(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'JwVideoArticle');
        return <StandaloneJwVideoArticle {...mergeProps({ options: { theme } }, props)} />;
    }
}